import {CartItem, FoodItem} from "../../types";
import {toast} from "react-toastify";
import {MdShoppingBasket} from "react-icons/md";
import {getFoodById} from "./functions";
const DELIVERY_PRICE = 300;
export const fetchCartData = async (foodItems: any, dispatch: any) => {
    if (localStorage.getItem("CartItems")) {
        const itemsFromLocal = localStorage.getItem("CartItems")
        const totalItems: CartItem[] = JSON.parse(itemsFromLocal !== null ? itemsFromLocal : '[]')
        dispatch({
            type: "SET_CART_ITEMS",
            cartItems: totalItems,
        });
        calculateCartTotal(totalItems, foodItems, dispatch);
    }
};

export const addToCart = async (
    cartItems: CartItem[],
    foodItems: FoodItem[],
    fid: number,
    dispatch: any) => {
    if (cartItems.some((item: CartItem) => item["fid"] === fid)) {
        toast.error("Уже в корзине", {
            icon: <MdShoppingBasket className="text-2xl text-cartNumBg"/>,
            toastId: "itemAlreadyInCart",
        });
    } else {
        const data: CartItem = {
            id: Date.now(),
            fid: fid,
            quantity: 1,
        };
        const totalItems: CartItem[] = [...cartItems, data]
        dispatch({
            type: "SET_CART_ITEMS",
            cartItems: totalItems,
        });
        calculateCartTotal(cartItems, foodItems, dispatch);
        localStorage.setItem("CartItems", JSON.stringify(totalItems));
    }
};

export const calculateCartTotal = (
    CartItems: CartItem[],
    foodItems: FoodItem[],
    dispatch: any
) => {
    let total = 0;
    CartItems.forEach((item: CartItem) => {
        const foodItem = getFoodById(foodItems, item.fid);
        total += item.quantity * parseFloat(foodItem?.price || "0");
    });
    total += DELIVERY_PRICE
    dispatch({
        type: "SET_CART_TOTAL",
        cartTotal: total.toFixed(2),
    });
};

export const updateCartItemQty = async (
    cartItems: CartItem[],
    foodItems: FoodItem[],
    item: CartItem,
    dispatch: any,
    val: number
) => {
    const index = cartItems.findIndex(
        (CartItem: CartItem) => CartItem.id === item.id
    );
    if (index !== -1) {
        cartItems[index].quantity += val;
        dispatch({
            type: "SET_CART_ITEMS",
            cartItems: cartItems,
        });
        calculateCartTotal(cartItems, foodItems, dispatch);
        localStorage.setItem("CartItems", JSON.stringify(cartItems));
    }
};

export const deleteCartItem = async (
    cartItems: CartItem[],
    foodItems: FoodItem[],
    item: CartItem,
    dispatch: any
) => {
    const index = cartItems.findIndex(
        (CartItem: CartItem) => CartItem.id === item.id
    );
    if (index !== -1) {
        cartItems.splice(index, 1);
        dispatch({
            type: "SET_CART_ITEMS",
            cartItems: cartItems,
        });
        calculateCartTotal(cartItems, foodItems, dispatch);
        localStorage.setItem("CartItems", JSON.stringify(cartItems));
    }
};

export const emptyCart = async (
    CartItems: CartItem[],
    foodItems: FoodItem[],
    dispatch: any
) => {
    if (CartItems.length > 0) {
        dispatch({
            type: "SET_CART_ITEMS",
            cartItems: [],
        });
        calculateCartTotal(CartItems, foodItems, dispatch);
    } else {
        toast.warn("Корзина уже пуста");
    }
};